module.exports = "/_next/static/images/wrath_white_appstore_playstore_2026_440w-ccb5db9c85733c020cf34a010034628f.webp";